const regex = /^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{3}=|[A-Za-z\d+/]{2}==)?$/;

function isBase64(value: string): boolean {
    return regex.test(value);
}

export default isBase64;
